export const locale = {
  lang: 'en',
  data: {
    memberBills: {
      list: {
        billDate: 'Bill date',
        paymentDate: 'Payment date',
        memberBillCode: 'Bill number',
        amount: 'Amount',
        isCanceled: 'Bill cancelled',
        batchCode: 'Batch number',
        item: 'Article',
        quantity: 'Quantity',
        total: 'Total',
        payedAmount: 'Payed amount',
        origin: 'Origin',
        billType: 'Bill type',
        billTypeLegalEntity: 'Corporate practice',
        billTypeMemberTableau: 'Member registry',
        source: 'Source',
        legalEntityName: 'Legal entity',
      },
      actions:{
        showBill:'Display bill',
        payInvoice:'Pay invoice'
      },
      report:{
        title:'Invoice',
        loadErrorTitle: 'Invoice',
        loadError: 'Unable to open the invoice. Please try again later.'
      },
      invoicePayment:{
        title:'Invoice payment',
        amountToPay:'Amount to pay',
        nameUnderCard:'Name on card',
        reassuranceMessage:'Please try again or contact customer service if the problem persists.',
        paymentSuccessful: 'Payment Successful',
        transactionId: 'Transaction ID',
        date: 'Date',
        amount: 'Amount',
        cardType: 'Card Type',
        cardNumber: 'Card Number',
        authorization: 'Authorization Number',
        thankYou: 'Thank you for your payment. Your invoice has been processed successfully.',
        total: 'Total',
        billLines: 'Bill Lines',
        errors: {
          noBillsFound: 'No bills found for payment',
          inscriptionBillNotPayable: 'This registration invoice cannot be paid here. Please use the annual registration payment process.',
          sumOrMonerisError: 'An error occurred during payment processing',
          transactionError: 'Transaction declined by the card issuer',
          paymentError: 'An error occurred during payment processing. Please try again.'
        }
      }
    },
    list: {
      noData: 'No available data',
    }
  }
}